import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const HaleroveVyrovnani = {
	name: NAME,
	apiProvider,
	router,
};
